export default {
    /**
     * Get 応募者一覧取得
     */
    loadApplies (page = 1) {
        return axios.get(route('app.init') + '?page=' + page)
    },

    /**
     * Get 応募者一覧取得(See More)
     */
    loadAppliesSeeMore (data) {
        return axios.get(data)
    },

    /**
     * Get 応募状況詳細取得
     */
    loadApplyStatusDetail (id) {
        return axios.get(route('app.status.detail', id))
    },

    /**
     * Post 応募状況保存
     */
    saveApplyStatus (data) {
        return axios.post(route('app.status.save'), data)
    },

    /**
     * Post 要員提案情報保存
     */
    saveApplyTech (data) {
        return axios.post(route('app.tech.save'), data)
    },

    /**
     * Get 履歴書情報取得
     */
    loadContractInfo (data) {
        return axios.get(route('app.contract.detail', data.id))
    },

    /**
     * Post 契約保存・更新
     */
    saveContractInfo (data) {
        return axios.post(route('app.contract.save'), data)
    },

    /**
     * Get 応募詳細取得
     */
    loadAppDetail (id) {
        return axios.get(route('app.detail', id))
    },

    /**
     * Post 単価公開
     */
    applyPricePub (data) {
        return axios.post(route('app.price.pub'), data)
    },

    /**
     * Post 氏名公開
     */
    techNamePub (data) {
        return axios.post(route('app.name.pub'), data)
    },

    /**
     * Post 応募情報承認
     */
    approvalApply (data) {
        return axios.post(route('app.approval'), data)
    },

    /**
     * Post 入場確定
     */
    enterConfirm (data) {
        return axios.post(route('app.enter.confirm'), data)
    },

    /**
     * Post 面接・入場取消
     */
    cancelIntv (data) {
        return axios.post(route('interview.cancel'), data)
    },

    /**
     * Post 契約期間
     */
    contractPeriodSave (data) {
        return axios.post(route('app.contract.save'), data)
    },

    /**
     * Post 現場中など
     */
    loadWorkStatus (data) {
        return axios.post(route('app.work.status'), data)
    },

    /**
     * Post 退場確定
     */
    exitConfirmSave (data) {
        return axios.post(route('app.work.exit.confirm'), data)
    },

    /**
     * Post 退場済みに変更
     */
    changeToExited (data) {
        return axios.post(route('app.work.exit.done'), data)
    },

    /**
     * Post 面接備考追加
     */
    addPrice (data) {
        return axios.post(route('price.add'), data)
    },

    /**
     * Post 面接追加
     */
    addInterview (data) {
        return axios.post(route('interview.add'), data)
    },

    /**
     * Post 面接備考追加
     */
    addNote (data) {
        return axios.post(route('note.add'), data)
    },

    /**
     * Post 書類選考NG通知
     */
    sendMailDocNG (data) {
        return axios.post(route('document.ng'), data)
    },

    /**
     * Post 面接NG通知
     */
    sendMailIntvNG (data) {
        return axios.post(route('interview.ng'), data)
    },

    /**
     * Post 面接OK通知
     */
    sendMailIntvOK (data) {
        return axios.post(route('interview.ok'), data)
    },

    /**
     * Post 面接OK通知(次回面接あり)
     */
    sendMailIntvOKWithNext (data) {
        return axios.post(route('interview.ok.next'), data)
    },

    /**
     * Get 入場予定詳細
     */
    loadEnterDetail (day) {
        return axios.get(route('app.enter.detail', day))
    },
}
